import { Category, SavingsAccountMetadata } from '@square/dashboard-protos/models/squareup/banking/account_model';
import { FolderCategoryLabel } from './types';

// eslint-disable-next-line complexity
export function getSvgNameForCategory(category) {
  switch (category) {
    case SavingsAccountMetadata.Category.RAINY_DAY:
    case Category.RAINY_DAY:
      return '24px-cloud';
    case SavingsAccountMetadata.Category.TAX:
    case SavingsAccountMetadata.Category.SALES_TAX:
    case Category.TAX:
      return '24px-percentage';
    case SavingsAccountMetadata.Category.CUSTOM:
    case Category.CUSTOM:
      return '24px-file';
    case SavingsAccountMetadata.Category.PAYROLL:
    case Category.PAYROLL:
      return '24px-payroll';
    case SavingsAccountMetadata.Category.RENT:
    case Category.RENT:
      return '24px-buildings';
    case SavingsAccountMetadata.Category.EDUCATION:
    case Category.EDUCATION:
      return '24px-briefcase';
    case SavingsAccountMetadata.Category.EXPENSE:
    case Category.EXPENSE:
      return '24px-cash-arrow';
    case SavingsAccountMetadata.Category.GIVING:
    case Category.GIVING:
      return '24px-donation';
    case SavingsAccountMetadata.Category.PROFIT:
    case Category.PROFIT:
      return '24px-dollar-stack';
    case SavingsAccountMetadata.Category.RETIREMENT:
    case Category.RETIREMENT:
      return '24px-trophy';
    case SavingsAccountMetadata.Category.VEHICLE_GAS:
    case Category.VEHICLE_GAS:
      return '24px-car';
    case SavingsAccountMetadata.Category.GENERAL_SAVINGS:
    default:
      return '24px-money-bag';
  }
}

// eslint-disable-next-line complexity
export function getFolderLabelForCategory(category) {
  switch (category) {
    case SavingsAccountMetadata.Category.RAINY_DAY:
    case Category.RAINY_DAY:
      return FolderCategoryLabel.RainyDay;
    case SavingsAccountMetadata.Category.TAX:
    case SavingsAccountMetadata.Category.SALES_TAX:
    case Category.TAX:
      return FolderCategoryLabel.Tax;
    case SavingsAccountMetadata.Category.CUSTOM:
    case Category.CUSTOM:
      return FolderCategoryLabel.Custom;
    case SavingsAccountMetadata.Category.PAYROLL:
    case Category.PAYROLL:
      return FolderCategoryLabel.Payroll;
    case SavingsAccountMetadata.Category.RENT:
    case Category.RENT:
      return FolderCategoryLabel.Rent;
    case SavingsAccountMetadata.Category.EDUCATION:
    case Category.EDUCATION:
      return FolderCategoryLabel.Education;
    case SavingsAccountMetadata.Category.EXPENSE:
    case Category.EXPENSE:
      return FolderCategoryLabel.Expense;
    case SavingsAccountMetadata.Category.GIVING:
    case Category.GIVING:
      return FolderCategoryLabel.Giving;
    case SavingsAccountMetadata.Category.PROFIT:
    case Category.PROFIT:
      return FolderCategoryLabel.Profit;
    case SavingsAccountMetadata.Category.RETIREMENT:
    case Category.RETIREMENT:
      return FolderCategoryLabel.Retirement;
    case SavingsAccountMetadata.Category.VEHICLE_GAS:
    case Category.VEHICLE_GAS:
      return FolderCategoryLabel.VehicleGas;
    default:
      throw new Error('Unexpected folder category');
  }
}
export function isSalesTaxAccount(category) {
  return category === SavingsAccountMetadata.Category.SALES_TAX;
}